import { Component } from '@angular/core';
import { NavController, NavParams,LoadingController } from 'ionic-angular';
import {DriverServiceProvider} from '../../../providers/dvm/driver-service';
import { ParcelDetailPage } from '../parcel_detail/index';

@Component({
  selector: 'page-list',
  templateUrl: 'index.html',
  providers: [DriverServiceProvider]
})
export class ParcelListPage {
 header_data:any;

  objectKeys = Object.keys;
  icons: string[];
  items: Array<{title: string, note: string, icon: string}>;
  waybills:any;
  public drivers_list: any;

  constructor(public navCtrl: NavController, public navParams: NavParams,public driverService: DriverServiceProvider,public loadingCtrl: LoadingController) {
    this.header_data={ismenu:true,ishome:false,title:navParams.data.page_title+" "+navParams.data.name+" "};
       console.log(navParams.data.page_title+'  Parcels Page Open');
       console.log(navParams.data.data);
    this.waybills=navParams.data.data;
  }



  
      
    openParcelDetail(awb) {
           console.log('Driver  Parcels Page Loaded');
           this.navCtrl.push(ParcelDetailPage,awb);
  }





}



// WEBPACK FOOTER //
// ./src/pages/wh/parcels_list/index.ts